import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["prefixCls"];
import React, { Component } from 'react';
import Rates from 'rc-rate';
import Icon from '../../wui-icon/src';
import PropTypes from 'prop-types';
import { WebUI, prefix } from "../../wui-core/src/index.js";
var propTypes = {
  count: PropTypes.number,
  value: PropTypes.number,
  defaultValue: PropTypes.number,
  onChange: PropTypes.func,
  onHoverChange: PropTypes.func,
  allowHalf: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};
var defaultProps = {
  count: 5,
  defaultValue: 0,
  value: 0,
  onChange: function onChange() {},
  onHoverChange: function onHoverChange() {},
  allowHalf: false,
  disabled: false,
  character: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-star"
  }),
  className: '',
  style: {}
};
/*@WebUI({name: "rate", defaultProps})
class Rate extends Component {
    render() {
        const {count, value, defaultValue, onChange, clsPrefix, onHoverChange, allowHalf, disabled, character, className, style, ...others} = this.props;
        return (
                <Rates prefixCls={clsPrefix} count={count} value={value}  defaultValue={defaultValue} onChange={onChange}
                       onHoverChange={onHoverChange} allowHalf={allowHalf} disabled={disabled} character={character}
                       className={className} style={style} {...others}/>
        )
    }
};*/
// autoFocus属性和 focus, blur方法的支持

var Rate = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var prefixCls = _ref.prefixCls,
      props = _objectWithoutProperties(_ref, _excluded);

  var ratePrefixCls = "".concat(prefix, "-rate");
  return /*#__PURE__*/React.createElement(Rates, _extends({
    ref: ref
  }, props, {
    prefixCls: ratePrefixCls
  }));
});
Rate.displayName = 'Rate';
Rate.propTypes = propTypes;
Rate.defaultProps = defaultProps;
export default Rate;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-rate/src/Rate.js